<div class="row">
    <div class="col-sm-1"></div>
    <div class="col-sm-10">

    </div>
    <div class="col-sm-1"></div>
</div>
<div class="container border roundcorner" style="margin-top:120px">

    <img class="logo-img-x forminlinemargin" src="assets/img/Skd link landscape T2 blu.png">
    <h2 class="text-register forminlinemargin">Ayo Daftar</h2>
    <form [formGroup]="registerForm" (ngSubmit)="submitForm()">
        <div class="form-inline">

            <input type="text" class="form-control forminlinemargin" placeholder="PIC" name="pic">
            <input type="email" class="form-control forminlinemargin" placeholder="Email" name="email">
            <input type="text" class="form-control forminlinemargin" placeholder="Phone Number" name="phonenumber">
            <input type="text" class="form-control forminlinemargin" placeholder="Sold-To" name="soldto">
        </div>


        <div class="row">
            <div class="col-sm-6">
                <h1 class="text-register">Customer Information</h1>
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="Name" name="name">
                </div>
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="KTP/NPWP" name="nik">
                </div>

                <div class="form-group">
                    <input type="text" class="form-control" placeholder="Address" name ="address">
                </div>
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="City" name="city">
                </div>

                <div class="form-group">
                    <button type="button" class="btn btn-secondary">Browse</button>
                    <label class="labelregister">Foto data diri dan KTP</label>
                </div>
                <div class="form-group">
                    <button type="button" class="btn btn-secondary">Browse</button>
                    <label class="labelregister">Lampiran persetujuan dari CEO/direktur</label>
                </div>
                <div class="form-group">

                    <button type="button" class="btn btn-primary">Submit</button>
                    <label>*Dengan melanjutkan kelangkah berikutnya, anda menyetujui semua
                        <a href="url">syarat & ketentuan</a> serta
                        <a href="url"> kebijakan privasi</a> yang berlaku
                    </label>

                </div>

            </div>
            <div class="col-sm-6 bgx bg-img2">

            </div>
        </div>
    </form>

</div>
